<script>
import { mapState } from "vuex";

export default {
  name: "App",

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("toast", ["message", "options"])
  },

  methods: {
    initializeChat() {
      if (this.user) {
        $crisp.push(["set", "user:email", [this.user.email]]);
      }
    }
  },

  watch: {
    message(newMessage, oldMessage) {
      if (newMessage !== "") {
        this.$toasted.show(this.message, {
          ...this.options,
          className: ["toasted-default"]
        });
      }
    }
  }
};
</script>

<template>
  <div id="app">
    <transition name="down" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<style>
@import "assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue